import { mkChartOfAccount } from 'data/chartOfAccounts/types';
import { List as ImmutableList } from 'immutable';

import moment from 'moment';
import { DateTime } from 'luxon';

import { mkTag } from 'data/tags/types';

import { exists } from 'utils/utils';
import * as types from './types';


export const { mkSplit, mkSplitItem, mkSplitItems } = types;

export function transformTransactionToRequestData(transaction) {
  switch (transaction.type) {
    case 'CASH_FLOW':
      return tranformCashFlowTxnToRequestData(transaction);
    default:
      return null;
  }
}

export function transformRequestDataToTransaction(transaction) {
  switch (transaction.type) {
    case 'CASH_FLOW':
      return tranformApiDataToCashFlowTxn(transaction);
    default:
      return null;
  }
}

export function transformResponseToTransactions(response) {
  return response.data.resources.map((transaction) => transformRequestDataToTransaction(transaction));
}

// /////////////////////////////////////////////////////////////////////////////
// Transformers for Transaction API Responses to Transactions
// /////////////////////////////////////////////////////////////////////////////

export function tranformApiDataToCashFlowTxn(data) {
  return new types.CashFlowTransaction({
    ...transformApiDataToTransactionMap(data),
    check: data.check,
    coordinates: data.coordinates,
  });
}

function transformApiDataToTransactionMap(data) {

  // console.log("TRANSFORM API DATA TO TRANSACTION MAP ", data);

  const ret = ({
    id: data.id,

    accountId: data.accountId,
    clientId: data.clientId,
    postedOn: moment(data.postedOn).toISOString(),  // was Date.parse(data.postedOn), why parse QCS data?  this broke dates

    payee: data.payee,
    memo: data.memo,
    coa: data.coa ?
      mkChartOfAccount({ id: data.coa.id, type: data.coa.type }) :
      null,
    amount: data.amount,

    tags: data.tags ? new ImmutableList(data.tags.map((tag) => mkTag(tag))) : undefined,
    attachments: data.attachments,

    split: data.split ? mkSplit(data.split) : undefined,
    state: data.state,
    matchState: data.matchState,
    isReviewed: data.isReviewed,
    transfer: data.transfer,

    cpData: data.cpData,

    source: data.source,
    stModelId: data.stModelId,
    stDueOn: data.stDueOn,
    paymentProvider: data.paymentProvider,

    modifiedAt: data.modifiedAt,
    isDeleted: data.isDeleted ? data.isDeleted : false,

    isExcludedFromReports: data.isExcludedFromReports,
    isExcludedFromF2S: data.isExcludedFromF2S,

    userFlag: data.userFlag,
    userFlagNote: data.userFlagNote,

    matchedTxnId: data.matchedTxnId,

    isBill: data.isBill,
    isSubscription: data.isSubscription,
  });
  // console.log("RETURNING ", ret);
  return ret;
}

// /////////////////////////////////////////////////////////////////////////////
// Transformers for Transactions to Transaction API Request Data
// /////////////////////////////////////////////////////////////////////////////

function tranformCashFlowTxnToRequestData(transaction) {
  return {
    type: 'CASH_FLOW',
    ...transformBaseTransactionToRequestData(transaction),
    check: transaction.check,
    // coordinates: transaction.coordinates,
  };
}

function transformBaseTransactionToRequestData(transaction) {
  return {
    id: transaction.id === '0' ? null : transaction.id,

    accountId: transaction.accountId,
    clientId: transaction.clientId,
    postedOn: transaction.postedOn ?
      moment(transaction.postedOn).format('YYYY-MM-DD') :
      null,

    payee: transaction.payee,
    memo: transaction.memo,
    coa: transaction.coa ?
      {
        type: transaction.coa.type,
        id: transaction.coa.id,
      } :
      null,
    amount: exists(transaction.amount) ? parseFloat(transaction.amount) : null,

    tags: transaction.tags && transaction.tags.map((tag) => ({ id: tag.id })).toJS(), // toJS(),
    attachments: transaction.attachments,

    split: transaction.split && transaction.split.toJS(),
    state: transaction.state,
    matchState: transaction.matchState,
    isReviewed: transaction.isReviewed,
    //
    // We treat all changes from webApp as USER INITIATED changes
    //
    userModifiedAt: DateTime.utc().toISO(),

    cpData: transaction.cpData,

    source: transaction.source,
    stModelId: transaction.stModelId,
    stDueOn: transaction.stDueOn,
    paymentProvider: transaction.paymentProvider,

    isExcludedFromF2S: transaction.isExcludedFromF2S,
    isExcludedFromReports: transaction.isExcludedFromReports,

    userFlag: transaction.userFlag,
    userFlagNote: transaction.userFlagNote,

    isDeleted: transaction.isDeleted ? transaction.isDeleted : false,
    transfer: transaction.transfer,

    isBill: transaction.isBill,
    isSubscription: transaction.isSubscription,
  };
}





